'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemplateApplicationSubHeader = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

exports.validateTemplatesMId = validateTemplatesMId;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _fetchStatusTypes = require('constants/fetchStatusTypes');

var STATUS = _interopRequireWildcard(_fetchStatusTypes);

var _templates = require('redux/modules/templates');

var _templatesSettings = require('redux/modules/templates/templatesSettings');

var _components = require('components');

var _modals = require('constants/modals');

var _modals2 = require('redux/modules/modals');

var _TemplateApplication = require('./TemplateApplication.scss');

var _TemplateApplication2 = _interopRequireDefault(_TemplateApplication);

var _notifications = require('redux/modules/notifications');

var _errorMsgs = require('constants/errorMsgs');

var _TemplateApplicationSubHeader2 = require('./TemplateApplicationSubHeader');

var _TemplateApplicationSubHeader3 = _interopRequireDefault(_TemplateApplicationSubHeader2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateApplication = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TemplateApplication, _Component);

  function TemplateApplication(props) {
    (0, _classCallCheck3.default)(this, TemplateApplication);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TemplateApplication.__proto__ || (0, _getPrototypeOf2.default)(TemplateApplication)).call(this, props));

    _this._onClone = function (template) {
      if (_this.props.cloneTemplate) _this.props.cloneTemplate(template);
    };

    _this._onEnabledChange = function (rowId) {
      return function (e) {
        if (_this.props.changeTemplatesRowProperty) {
          _this.props.changeTemplatesRowProperty(e.target.name, e.target.checked, rowId);
        }
      };
    };

    _this._onDefaultChange = function (id) {
      return function (e) {
        if (_this.props.changeTemplatesProperty) {
          _this.props.changeTemplatesProperty(e.target.name, Number(id));
        }
      };
    };

    _this._onCheckBoxChange = function (e) {
      var templates = _this.props.templates;

      if (_this.props.changeTemplateApplicationSettingsProperty) {
        if (e.target.id == 'autoDetectTemplate') {
          var allHaveMId = validateTemplatesMId(templates);
          if (!allHaveMId) {
            _this.props.errorPopUp({
              title: 'Error',
              message: _errorMsgs.ERR_MISS_MARKING_ID
            });
          } else {
            _this.props.changeTemplateApplicationSettingsProperty(e.target.name, e.target.checked);
          }
        } else {
          _this.props.changeTemplateApplicationSettingsProperty(e.target.name, e.target.checked);
        }
      }
    };

    _this._onInputChange = function (e) {
      if (_this.props.changeTemplateApplicationSettingsProperty) {
        _this.props.changeTemplateApplicationSettingsProperty(e.target.name, e.target.value);
      }
    };

    _this._onRemove = function (id) {
      var confirmMessage = 'THE TEMPLATE WILL BE DELETED, ARE YOU SURE YOU WANT TO CONTINUE?';
      _this.props.showModal(_modals.CONFIRM, {
        body: confirmMessage,
        onCancel: function onCancel() {
          return _this.props.hideModal(_modals.CONFIRM);
        },
        onConfirm: function onConfirm() {
          _this.props.hideModal(_modals.CONFIRM);
          _this.props.deleteTemplate(id);
        }
      });
    };

    _this._addTemplate = function () {
      // Currently done this way since table needs a function to work with
      _reactRouter.browserHistory.push('/template-application/template-configuration');
    };

    _this.handleDisplayLastDate = _this.handleDisplayLastDate.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(TemplateApplication, [{
    key: 'handleDisplayLastDate',
    value: function handleDisplayLastDate() {}

    /* Maybe here, it is not necessary to preload data on the server
    static preload = () => [
      [fetchTemplatesSaga, getTemplates.base()],
    ];
    */

  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!__SERVER__ && this.props.templatesStatus === STATUS.UNRETRIEVED) {
        this.props.getTemplates(this.props.codedToken);
      }
      if (!__SERVER__ && this.props.templatesSettingsStatus === STATUS.UNRETRIEVED) {
        this.props.getTemplatesSettings(this.props.codedToken);
      }
    }
  }, {
    key: '_renderSeparator',
    value: function _renderSeparator() {
      return _react2.default.createElement('div', { className: _TemplateApplication2.default.defaultSeparator });
    }
  }, {
    key: '_getTableColumns',
    value: function _getTableColumns() {
      var _this2 = this;

      var defaultTemplateId = this.props.defaultTemplateId;

      return [{
        property: 'name',
        header: {
          label: 'TEMPLATE NAME'
        },
        editable: false,
        visible: true,
        props: {
          style: {
            width: 300,
            minWidth: 300
          }
        }
      }, {
        property: 'markingId',
        header: {
          label: 'TEMPLATE MARKING ID'
        },
        editable: false,
        visible: true,
        props: {
          style: {
            width: 300,
            minWidth: 300
          }
        }
      }, {
        property: 'description',
        header: {
          label: 'Description'
        },
        editable: false,
        visible: true,
        props: {
          style: {
            minWidth: 400
          }
        }
      }, {
        property: 'enabled',
        header: {
          label: 'LIVE'
        },
        editable: false,
        visible: true,
        props: {
          style: {
            width: 100,
            textAlign: 'center'
          }
        },
        cell: {
          format: function format(value, _ref) {
            var rowData = _ref.rowData;

            if (rowData.isDefault) {
              return null;
            } else {
              var isEnabled = false;
              if (rowData.enabled === true || rowData.enabled === 'True') isEnabled = true;

              return _react2.default.createElement(_components.EnterpriseCheckBox, {
                className: _TemplateApplication2.default.ssl,
                id: 'enabled-' + rowData.id,
                name: 'enabled',
                onChange: _this2._onEnabledChange(rowData.id),
                checked: isEnabled
              });
            }
          }
        }
      }, {
        property: 'isDefault',
        header: {
          label: 'DEFAULT'
        },
        editable: false,
        visible: true,
        props: {
          style: {
            width: 100,
            textAlign: 'center'
          }
        },
        cell: {
          format: function format(value, _ref2) {
            var rowData = _ref2.rowData;

            var isDefault = false;
            if (Number(rowData.id) === Number(defaultTemplateId)) {
              isDefault = true;
            }

            return _react2.default.createElement(_components.EnterpriseRadioButton, {
              className: _TemplateApplication2.default.radioButton,
              id: 'default-' + rowData.id,
              name: 'defaultTemplateId',
              onChange: _this2._onDefaultChange(rowData.id),
              checked: isDefault
            });
          }
        }
      }, {
        header: {
          label: 'CLONE'
        },
        props: {
          style: {
            width: 100,
            textAlign: 'center'
          }
        },
        cell: {
          format: function format(value, _ref3) {
            var rowData = _ref3.rowData;
            return _react2.default.createElement(_components.EnterpriseIcons.Copy, {
              fill: '#005D8C',
              width: 40,
              height: 40,
              className: _TemplateApplication2.default.copyItem,
              onClick: function onClick() {
                return _this2._onClone(rowData);
              }
            });
          }
        }
      }, {
        header: {
          label: 'CONFIGURE'
        },
        props: {
          style: {
            width: 130,
            textAlign: 'center'
          }
        },
        cell: {
          format: function format(value, _ref4) {
            var rowData = _ref4.rowData;

            if (rowData.isDefault) {
              return null;
            } else {
              return _react2.default.createElement(
                _reactRouter.Link,
                { to: '/template-application/template-configuration/' + rowData.id },
                _react2.default.createElement(_components.EnterpriseIcons.Config, {
                  fill: '#005D8C',
                  width: 40,
                  height: 40,
                  className: _TemplateApplication2.default.rootItemTitleIcon
                })
              );
            }
          }
        }
      }, {
        props: {
          style: {
            width: 100,
            textAlign: 'center'
          }
        },
        cell: {
          format: function format(value, _ref5) {
            var rowData = _ref5.rowData;

            if (rowData.isDefault) {
              return null;
            } else {
              return _react2.default.createElement(_components.EnterpriseIcons.Trash, {
                fill: '#005D8C',
                width: 40,
                height: 40,
                className: _TemplateApplication2.default.trashItem,
                onClick: function onClick() {
                  return _this2._onRemove(rowData.id);
                }
              });
            }
          }
        }
      }];
    }
  }, {
    key: '_renderTemplateTable',
    value: function _renderTemplateTable() {
      // TODO: This is just for testing, need to be developed later.
      var templates = this.props.templates;

      var columns = this._getTableColumns();

      // TODO find a way to receive the templates as an array instead of mapping it
      var templatesArray = (0, _keys2.default)(templates).map(function (key) {
        return templates[key];
      }).sort(function (a, b) {
        return (a.isDefault ? 0 : 1) - (b.isDefault ? 0 : 1);
      });
      return _react2.default.createElement(_components.EnterpriseTable, {
        rows: templatesArray || [],
        rowKey: 'id',
        columns: columns,
        tableWidth: '100%',
        tableHeight: 600,
        pagination: { page: 1, perPage: 10 },
        addAction: true,
        onAdd: this._addTemplate,
        onPropertyChange: this._onTemplatesChange,
        style: { minWidth: '1000px' },
        tableLayout: 'auto'
      });
    }
  }, {
    key: '_renderTemplateWrapper',
    value: function _renderTemplateWrapper() {
      // TODO: This is just for testing, need to be developed later.
      return _react2.default.createElement(
        'div',
        { className: _TemplateApplication2.default.templatesWrapper },
        this._renderTemplateTable()
      );
    }

    // TODO: maybe it is a good idea de separate this into another component

  }, {
    key: '_renderTemplateApplicationSettings',
    value: function _renderTemplateApplicationSettings() {
      var _props = this.props,
          templatesSettings = _props.templatesSettings,
          templates = _props.templates;

      var autodetectDisabled = templates && (0, _keys2.default)(templates).length > 1 ? false : true;
      var validatedMid = validateTemplatesMId(templates);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.EnterpriseGrid.Row,
          null,
          _react2.default.createElement(
            _components.EnterpriseGrid.Col,
            { xs: 12 },
            _react2.default.createElement(_components.EnterpriseCheckBox, {
              id: 'autoDetectTemplate',
              name: 'autoDetectTemplate',
              label: 'AUTO DETECT TEMPLATE TO APPLY',
              disabled: autodetectDisabled,
              checked: validatedMid && (templatesSettings.autoDetectTemplate || false),
              onChange: this._onCheckBoxChange
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _TemplateApplication2.default.applicationSettingsContainer },
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            null,
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, className: _TemplateApplication2.default.applicationMarkings },
              _react2.default.createElement(
                'div',
                { className: _TemplateApplication2.default.markingLabel },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'galileoTemplateMarking' },
                  'GALILEO TEMPLATE MARKING'
                )
              ),
              _react2.default.createElement(_components.EnterpriseDropDown, {
                className: _TemplateApplication2.default.markingDropDown,
                disabled: validatedMid && !templatesSettings.autoDetectTemplate,
                name: 'galileoMarkingElement',
                options: [{ id: 'NP.', name: 'NP.', description: 'NP.' }, { id: 'DI.', name: 'DI.', description: 'DI.' }],
                value: templatesSettings.galileoMarkingElement || undefined,
                onChange: this._onInputChange,
                size: _components.ENTERPRISE_INPUT_SIZES.SMALL,
                height: _components.ENTERPRISE_INPUT_SIZES.MEDIUM
              }),
              _react2.default.createElement(_components.EnterpriseInput, {
                className: _TemplateApplication2.default.markingInput,
                disabled: validatedMid && !templatesSettings.autoDetectTemplate,
                name: 'galileoMarkingText',
                type: 'text',
                size: _components.ENTERPRISE_INPUT_SIZES.MEDIUM,
                onChange: this._onInputChange,
                value: templatesSettings.galileoMarkingText || ''
              })
            )
          ),
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            null,
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, className: _TemplateApplication2.default.applicationMarkings },
              _react2.default.createElement(
                'div',
                { className: _TemplateApplication2.default.markingLabel },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'apolloTemplateMarking' },
                  'APOLLO TEMPLATE MARKING'
                )
              ),
              _react2.default.createElement(_components.EnterpriseDropDown, {
                className: _TemplateApplication2.default.markingDropDown,
                disabled: validatedMid && !templatesSettings.autoDetectTemplate,
                name: 'apolloMarkingElement',
                options: [{ id: '@:5', name: '@:5', description: '@:5' }, { id: 'T-', name: 'T-', description: 'T-' }],
                value: templatesSettings.apolloMarkingElement || undefined,
                onChange: this._onInputChange,
                size: _components.ENTERPRISE_INPUT_SIZES.SMALL,
                height: _components.ENTERPRISE_INPUT_SIZES.MEDIUM
              }),
              _react2.default.createElement(_components.EnterpriseInput, {
                className: _TemplateApplication2.default.markingInput,
                disabled: validatedMid && !templatesSettings.autoDetectTemplate,
                name: 'apolloMarkingText',
                type: 'text',
                size: _components.ENTERPRISE_INPUT_SIZES.MEDIUM,
                onChange: this._onInputChange,
                value: templatesSettings.apolloMarkingText || ''
              })
            )
          ),
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            null,
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, className: _TemplateApplication2.default.applicationMarkings },
              _react2.default.createElement(_components.EnterpriseCheckBox, {
                disabled: !templatesSettings.autoDetectTemplate,
                name: 'useDefaultWhenAutoNotAplicable',
                label: 'USE DEFAULT WHEN AUTO IS NOT APPLICABLE',
                checked: validatedMid && (templatesSettings.useDefaultWhenAutoNotAplicable || false),
                onChange: this._onCheckBoxChange
              })
            )
          ),
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            null,
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, className: _TemplateApplication2.default.applicationMarkings },
              _react2.default.createElement(_components.EnterpriseCheckBox, {
                disabled: !templatesSettings.autoDetectTemplate,
                name: 'allowAgentsOverrideAuto',
                label: 'ALLOW AGENTS TO OVERRIDE AUTO TEMPLATE APPLICATION',
                checked: validatedMid && (templatesSettings.allowAgentsOverrideAuto || false),
                onChange: this._onCheckBoxChange
              })
            )
          )
        ),
        _react2.default.createElement(
          _components.EnterpriseGrid.Row,
          null,
          _react2.default.createElement(
            _components.EnterpriseGrid.Col,
            { xs: 12 },
            _react2.default.createElement(_components.EnterpriseCheckBox, {
              id: 'displayLastDateToPurchase',
              name: 'displayLastDateToPurchase',
              label: 'DISPLAY LAST DATE TO PURCHASE ON FLIGHT OPTIONS',
              checked: templatesSettings.displayLastDateToPurchase || false,
              onChange: this._onCheckBoxChange
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          error = _props2.error,
          templatesStatus = _props2.templatesStatus;


      return _react2.default.createElement(
        'div',
        { className: _TemplateApplication2.default.root },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Template Application' }),
        _react2.default.createElement(
          'div',
          { className: _TemplateApplication2.default.container },
          templatesStatus === STATUS.SUCCEEDED && this._renderTemplateWrapper(),
          templatesStatus === STATUS.FAILED && error && _react2.default.createElement(_components.EnterpriseError, { error: error })
        ),
        this._renderSeparator(),
        this._renderTemplateApplicationSettings()
      );
    }
  }]);
  return TemplateApplication;
}(_react.Component), _class.propTypes = {
  codedToken: _react.PropTypes.string,
  templates: _react.PropTypes.object,
  defaultTemplateId: _react.PropTypes.number,
  error: _react.PropTypes.object,
  templatesStatus: _react.PropTypes.string,
  templatesSettingsStatus: _react.PropTypes.string,
  templatesSettings: _react.PropTypes.object,
  getTemplates: _react.PropTypes.func,
  getTemplatesSettings: _react.PropTypes.func,
  changeTemplateApplicationSettingsProperty: _react.PropTypes.func,
  changeTemplatesProperty: _react.PropTypes.func,
  changeTemplatesRowProperty: _react.PropTypes.func,
  deleteTemplate: _react.PropTypes.func,
  cloneTemplate: _react.PropTypes.func,
  showModal: _react.PropTypes.func,
  hideModal: _react.PropTypes.func
}, _temp);
function validateTemplatesMId(templates) {
  var allHaveMId = true;

  (0, _keys2.default)(templates).map(function (key) {
    var obj = templates[key];
    if (obj.isDefault == false && !obj.markingId) {
      allHaveMId = false;
    }
  });
  return allHaveMId;
}

var mapStateToProps = function mapStateToProps(state) {
  var _state$templateApplic = state.templateApplication,
      _state$templateApplic2 = _state$templateApplic.templates,
      templates = _state$templateApplic2 === undefined ? {} : _state$templateApplic2,
      _state$templateApplic3 = _state$templateApplic.templatesSettings,
      templatesSettings = _state$templateApplic3 === undefined ? {} : _state$templateApplic3;
  var _templatesSettings$te = templatesSettings.temp,
      temp = _templatesSettings$te === undefined ? {} : _templatesSettings$te;


  return {
    codedToken: state.auth.codedToken,
    templates: templates.templates,
    defaultTemplateId: templates.defaultTemplateId,
    error: templates.error,
    templatesStatus: templates.templatesStatus,
    templatesSettings: temp,
    templatesSettingsStatus: templatesSettings.templatesSettingsStatus

  };
};

var getActions = function getActions() {
  return {
    changeTemplatesProperty: _templates.changeTemplatesProperty,
    changeTemplateApplicationSettingsProperty: _templatesSettings.changeTemplateApplicationSettingsProperty,
    changeTemplatesRowProperty: _templates.changeTemplatesRowProperty,
    getTemplates: _templates.getTemplates.base,
    getTemplatesSettings: _templatesSettings.getTemplatesSettings.base,
    deleteTemplate: _templates.deleteTemplate,
    cloneTemplate: _templates.cloneTemplate,
    showModal: _modals2.show,
    hideModal: _modals2.hide,
    errorPopUp: _notifications.error
  };
};

exports.TemplateApplicationSubHeader = _TemplateApplicationSubHeader3.default;
exports.default = (0, _reactRedux.connect)(mapStateToProps, getActions())(TemplateApplication);


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateApplication/TemplateApplication.jsx
// module id = 1640
// module chunks = 0